<template>
  <el-pagination
    v-model:current-page="page"
    v-model:page-size="size"
    :page-sizes="pageSizes"
    :layout="layout"
    :total="total"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
  />
</template>

<script lang="ts" setup>
import type { PropType } from "vue"
import { computed } from "vue"

const props = defineProps({
  total: {
    type: Number,
    default: 0,
  },
  currentPage: {
    type: Number,
    default: 1,
  },
  pageSize: {
    type: Number,
    default: 10,
  },
  layout: {
    type: String,
    default: "total, prev, pager, next", // 'total, sizes, prev, pager, next, jumper'
  },
  pageSizes: {
    type: Array as PropType<number[]>,
    default: () => [10, 20, 50, 100],
  },
})

const emit = defineEmits(["update:pageSize", "update:currentPage", "pagination"])

const size = computed({
  get: () => props.pageSize,
  set: (val) => {
    emit("update:pageSize", val)
  },
})

const page = computed({
  get: () => props.currentPage,
  set: (val) => {
    emit("update:currentPage", val)
  },
})

function handleSizeChange() {
  emit("pagination")
}

function handleCurrentChange() {
  emit("pagination")
}
</script>

<style scoped lang="scss"></style>
